import React, { createContext, useContext, useState } from 'react';

const UploadContext = createContext();

export function useUpload() {
    return useContext(UploadContext);
}

export function UploadProvider({ children }) {
    const [uploadState, setUploadState] = useState({
        uploading: false,
        uploadProgress: 0,
        uploadError: null,
        uploadSuccess: false,
        activeStep: 0,
        uploadStatus: '',
        uploadSpeed: '',
        selectedFile: null,
        fileId: null,
        meetingTime: null
    });

    const updateUploadState = (newState) => {
        setUploadState(prevState => ({
            ...prevState,
            ...newState
        }));
    };

    const resetUploadState = () => {
        setUploadState({
            uploading: false,
            uploadProgress: 0,
            uploadError: null,
            uploadSuccess: false,
            activeStep: 0,
            uploadStatus: '',
            uploadSpeed: '',
            selectedFile: null,
            fileId: null,
            meetingTime: null
        });
    };

    const value = {
        uploadState,
        updateUploadState,
        resetUploadState
    };

    return (
        <UploadContext.Provider value={value}>
            {children}
        </UploadContext.Provider>
    );
}
